import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import { mapActions } from 'vuex';
import TableList from '@/components/TableList';
import Pagination from '@/components/Pagination/index.vue';
import DialogForm from '@/components/DialogForm/index.vue';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { downloadWithIframe } from '@/common/download.js';
import _ from 'lodash';
import { format } from 'date-fns';
import { skeletonOptions, orderOptions } from '@/views/repository/resource/config/option.ts';
import { getOrderList as _getOrderList, assignDesign, backWardOrder, deliverMaterial, deliverOrder, rejectOrder, previewOrderProject } from '@/api/demand/order';
import { openPageByTokenQuery } from '@/utils/auth';
import { demandOrderStatusOptions } from '@pt/views/creative-service/demand-order-list/config.ts';
import { getFileExtension } from '@com/utils/file';
import { getModelIfrInfo, validateModel } from '@/views/repository/resource/config/form.ts';

export default {
  components: {
    SearchBar: SearchBar,
    TableList: TableList,
    Pagination: Pagination,
    DialogForm: DialogForm
  },

  mixins: [searchMixin],

  data: function data() {
    return {
      isConverCocosModel: '',
      listLoading: false,
      list: [],
      designerList: [],
      pagination: {
        total: 0
      },
      query: {
        page: 1,
        page_size: 15,
        search_field: 'id',
        keyword: '',
        adv_id: '',
        types: '',
        statuses: '',
        order: '-created_time'
      },
      formItemList: [{
        prop: 'search_field',
        type: 'select',
        class: 'offer-selector',
        params: {
          options: orderOptions
        }
      }, {
        prop: 'keyword',
        type: 'input',
        class: 'offer-input',
        params: {
          placeholder: '请输入关键词',
          clearable: true
        }
      }, {
        type: 'business',
        prop: 'adv_id',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          valueKey: 'id',
          clearable: true,
          placeholder: '请输入广告主'
        }
      }, {
        type: 'input',
        prop: 'types',
        params: {
          placeholder: '请输入工单类型',
          clearable: true
        }
      }, {
        type: 'select',
        prop: 'statuses',
        params: {
          clearable: true,
          placeholder: '请选择状态',
          options: demandOrderStatusOptions
        }
      }],
      dialog: {
        type: 0, // 1：分配设计  2：拒绝工单  3：上传模型  4：修改模型  5：交付工单
        uploaderVisible: false,
        config: {
          title: '',
          visible: false,
          loading: false,
          width: '520px',
          disabled: false,
          confirmLabel: '提交'
        },
        formConfig: {
          labelPosition: 'top'
        },
        value: {
          id: '',
          status: '',
          material_name: '',
          skeleton_type: '',
          estimated_deliver_date1: '',
          estimated_deliver_date2: '',
          designer_id: '',
          language: '',
          reason: '',
          ext_data: '',
          cover_url: '',
          deliver_url: '',
          check_url: '',
          confirm_delivery: '您确认交付该工单吗？',
          confirm_preview: '您确认登录 idg 进行预览该模型吗？',
          withdraw_Order: '您确认撤回该工单吗？'
        }
      },
      reasonList: [{ value: 'FBX内带有多个网格，需要控制FBX内只有一个网格。' }, {
        value: '模型资源顶点数，三角面数超过规定面数，麻烦提供规定面数顶点数要求的模型。'
      }, { value: 'zip包内缺少贴图。' }, { value: '上传资源格式不符合要求，请提供指定格式的模型资源。' }],
      formModel: {
        file_meta: {
          skeleton_count: 0,
          mesh_count: 0,
          material_count: 0,
          skin_count: 0,
          skeleton_names: [],
          face_count: 0,
          vertex_count: 0,
          has_vertices: false,
          has_normals: false,
          has_UVs: false,
          fps: 0,
          frames: 0
        }
      }
    };
  },

  methods: _extends({}, mapActions({
    convertCocosModel: 'creative/modelOrder/tryConvertCocosModel'
  }), {
    getOrderList: function getOrderList(query) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.listLoading = true;
                _context.next = 3;
                return _getOrderList(query);

              case 3:
                res = _context.sent;

                _this.listLoading = false;
                _this.list = _this.formatData(_.get(res, 'data.data.list') || []);
                _this.pagination.total = _.get(res, 'data.data.total');

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getDesignerList: function getDesignerList() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var designer;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.designerList.length) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return _this2.$store.dispatch('GetDesigner');

              case 3:
                designer = _this2.$store.getters.designer;

                _this2.designerList = designer.map(function (item) {
                  return {
                    value: item.id,
                    label: item.real_name
                  };
                });

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    formatData: function formatData(res) {
      var _this3 = this;

      var list = [];

      if (!Array.isArray(res)) {
        list = _.get(res, 'data.data.list') || [];
      } else {
        list = res;
      }

      return list.map(function (item) {
        return _extends({}, item, {
          estimated_deliver_time1: item.estimated_deliver_time1 ? format(item.estimated_deliver_time1 * 1000, 'YYYY-MM-DD') : '',
          estimated_deliver_time2: item.estimated_deliver_time2 ? format(item.estimated_deliver_time2 * 1000, 'YYYY-MM-DD') : '',
          created_time: format(item.created_time * 1000, 'YYYY-MM-DD'),
          updated_time: format(item.updated_time * 1000, 'YYYY-MM-DD'),
          deliver_time: item.deliver_time ? format(item.deliver_time * 1000, 'YYYY-MM-DD') : '',
          skeleton_type: useValueExchangeLabel(item.skeleton_type, skeletonOptions),
          designer_id: item.designer_id ? useValueExchangeLabel(item.designer_id, _this3.designerList) : ''
        });
      });
    },
    assignDesignId: function assignDesignId() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var data;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                data = _.pick(_this4.dialog.value, ['id', 'designer_id', 'estimated_deliver_date1', 'estimated_deliver_date2']);
                _context3.next = 4;
                return assignDesign(data);

              case 4:
                _this4.dialog.config.loading = false;
                _this4.dialog.config.visible = false;
                _this4.$message({ message: '分配成功', type: 'success' });
                _this4.getOrderList(_this4.query);
                _context3.next = 13;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](0);

                _this4.dialog.config.loading = false;

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[0, 10]]);
      }))();
    },
    getModelInfo: function getModelInfo(response) {
      this.dialog.config.disabled = true;
      this.dialog.config.loading = true;
      var modelUrl = response.data.files.find(function (url) {
        return getFileExtension(url) === 'glb' || getFileExtension(url) === 'gltf';
      }) || '';
      if (modelUrl) {
        getModelIfrInfo(modelUrl);
      } else {
        this.$message({
          type: 'error',
          message: '该文件中不包含 glb 或 gltf 格式的模型文件'
        });
        this.dialog.config.loading = false;
        this.dialog.config.disabled = true;
      }
    },
    checkConvertCocosModel: function checkConvertCocosModel() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var fileUrl, extData;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fileUrl = _this5.dialog.value.check_url;
                extData = JSON.parse(_this5.dialog.value.ext_data);
                _context4.next = 4;
                return _this5.convertCocosModel({
                  fileUrl: fileUrl,
                  extData: extData
                });

              case 4:
                _this5.isConverCocosModel = _context4.sent;

                _this5.dialog.config.loading = false;
                if (_this5.isConverCocosModel) _this5.dialog.config.disabled = false;

              case 7:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    rejectOrderItem: function rejectOrderItem() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                data = _.pick(_this6.dialog.value, ['id', 'reason']);
                _context5.next = 4;
                return rejectOrder(data);

              case 4:
                _this6.dialog.config.loading = false;
                _this6.dialog.config.visible = false;
                _this6.$message({ message: '操作成功', type: 'success' });
                _this6.getOrderList(_this6.query);
                _context5.next = 13;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](0);

                _this6.dialog.config.loading = false;

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[0, 10]]);
      }))();
    },
    withdrawOrder: function withdrawOrder(row) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return backWardOrder({ id: row.id, status: row.status });

              case 2:
                _this7.dialog.config.loading = false;
                _this7.dialog.config.visible = false;
                _this7.$message({ message: '撤回成功', type: 'success' });
                _this7.getOrderList(_this7.query);

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    validate3DModel: function validate3DModel() {
      return validateModel(this.useLabelExchangeValue(this.dialog.value.skeleton_type, skeletonOptions), this.formModel.file_meta);
    },
    downloadModel: function downloadModel(row, type) {
      var model_url = '';
      var cover_url = '';
      var name = '';
      var s3 = 'mws-files';
      if (type === 'customModel') {
        model_url = row.upload_url;
        name = row.material_name;
      } else {
        model_url = row.deliver_url;
        cover_url = row.cover_url;
        name = String(row.id);
      }
      if (cover_url) {
        downloadWithIframe(cover_url, undefined, false, true, s3);
      }
      name.includes('.zip') ? name : name = name + '.zip';
      downloadWithIframe(model_url, name, false, true, s3);
    },
    deliverMaterialItem: function deliverMaterialItem(method) {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var data;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                data = _.pick(_this8.dialog.value, ['id', 'cover_url', 'deliver_url']);
                _context7.next = 4;
                return deliverMaterial(data);

              case 4:
                _this8.dialog.config.loading = false;
                _this8.dialog.config.visible = false;
                method === 'upload' ? _this8.$message({ message: '上传成功', type: 'success' }) : _this8.$message({ message: '修改成功', type: 'success' });
                _this8.getOrderList(_this8.query);
                _context7.next = 13;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](0);

                _this8.dialog.config.loading = false;

              case 13:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8, [[0, 10]]);
      }))();
    },
    deliverOrderItem: function deliverOrderItem() {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var data;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                data = _.pick(_this9.dialog.value, ['id']);
                _context8.next = 3;
                return deliverOrder(data);

              case 3:
                _this9.dialog.config.loading = false;
                _this9.dialog.config.visible = false;
                _this9.$message({ message: '交付成功', type: 'success' });
                _this9.getOrderList(_this9.query);

              case 7:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    checkModelInfo: function checkModelInfo(event) {
      if (event.data.type !== 'PLAYABLE:gltfview') return;
      console.log('event', event);
      if (event.data.data.type === 'modelLoadSuccess') {
        var data = event.data.data.params.info;
        var geometry = data.geometries[0];
        this.formModel.file_meta = _extends({}, this.formModel.file_meta, {
          mesh_count: Math.floor(data.meshCount) || 0,
          material_count: Math.floor(data.materialCount) || 0,
          skin_count: Math.floor(data.skinCount) || 0,
          skeleton_count: Math.floor(data.boneNames && data.boneNames.length) || 0,
          skeleton_names: data.boneNames,
          face_count: geometry.index ? geometry.index.count / 3 : geometry.attributes.position.positionCount / 3,
          vertex_count: geometry.attributes.position.positionCount || 0,
          has_vertices: geometry.attributes.position !== undefined,
          has_normals: geometry.attributes.normal !== undefined,
          has_UVs: geometry.attributes.uv !== undefined
        });
        if (this.validate3DModel()) {
          this.$message.error(this.validate3DModel());
          this.dialog.config.loading = false;
          this.dialog.config.disabled = true;
          return;
        }
        this.checkConvertCocosModel();
      }
    },
    showDialog: function showDialog(obj, type) {
      this.dialog.config.visible = true;
      this.dialog.type = type;
      this.dialog.value.material_name = obj.material_name;
      this.dialog.value.language = obj.lang;
      this.dialog.value.skeleton_type = obj.skeleton_type;
      this.dialog.value.id = obj.id;
      this.dialog.value.ext_data = obj.ext_data;
      this.dialog.value.status = obj.status;
      switch (type) {
        case 1:
          this.dialog.config.title = '分配设计';
          break;
        case 2:
          this.dialog.config.title = '拒绝工单';
          break;
        case 3:
          this.dialog.config.title = '上传模型';
          break;
        case 4:
          this.dialog.config.title = '修改模型';
          break;
        case 5:
          this.dialog.config.title = '交付工单';
          this.dialog.config.confirmLabel = '确认';
          break;
        case 6:
          this.dialog.config.title = '预览效果';
          this.dialog.config.confirmLabel = '确认';
          break;
        case 7:
          this.dialog.config.title = '撤回工单';
          this.dialog.config.confirmLabel = '确认';
          break;
        default:
          break;
      }
    },
    submitDialogForm: function submitDialogForm() {
      this.dialog.config.loading = true;
      switch (this.dialog.type) {
        case 1:
          this.assignDesignId();
          break;
        case 2:
          this.rejectOrderItem();
          break;
        case 3:
          this.deliverMaterialItem('upload');
          break;
        case 4:
          this.deliverMaterialItem('update');
          break;
        case 5:
          this.deliverOrderItem();
          break;
        case 6:
          this.handlePreviewProject(this.dialog.value);
          break;
        case 7:
          this.withdrawOrder(this.dialog.value);
          break;
        default:
          break;
      }
    },
    handlePreviewProject: function handlePreviewProject(row) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _ref, data, extData;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;

                _this10.listLoading = true;
                _this10.dialog.config.loading = false;
                _this10.dialog.config.visible = false;
                _context9.next = 6;
                return previewOrderProject({
                  id: row.id
                });

              case 6:
                _ref = _context9.sent;
                data = _ref.data;
                extData = JSON.parse(row.ext_data);

                openPageByTokenQuery(_extends({
                  token: data.data.token,
                  source_project: 'gm',
                  source_project_id: data.data.preview_project_id,
                  preview_asset_id: data.data.order.preview_asset_id,
                  source_template_id: extData.tplId,
                  fileUrl: data.data.asset_url
                }, extData));
                _context9.next = 15;
                break;

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9['catch'](0);

                _this10.$message.error('预览失败');

              case 15:
                _context9.prev = 15;

                _this10.listLoading = false;
                return _context9.finish(15);

              case 18:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this10, [[0, 12, 15, 18]]);
      }))();
    },
    defaultInfo: function defaultInfo(types) {
      return types.includes(this.dialog.type);
    },
    useLabelExchangeValue: function useLabelExchangeValue(val, list) {
      var temp = list.filter(function (item) {
        return item.label === val;
      });
      if (temp.length > 0) return temp[0].value;
    }
  }),
  mounted: function mounted() {
    var _this11 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
      return _regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              window.addEventListener('message', _this11.checkModelInfo);
              _context10.next = 3;
              return _this11.getDesignerList();

            case 3:
              _this11.getOrderList(_this11.query);

            case 4:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this11);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.checkModelInfo);
  },

  computed: {
    tableColumnConfig: function tableColumnConfig() {
      return [{
        slot: 'action-cell'
      }, {
        label: '工单ID',
        prop: 'id',
        width: 90
      }, {
        label: '工单类型',
        prop: 'type'
      }, {
        label: '状态',
        prop: 'status',
        params: {
          innerText: function innerText(_ref2) {
            var row = _ref2.row;

            return useValueExchangeLabel(row.status, demandOrderStatusOptions);
          }
        }
      }, {
        label: '广告主名称',
        prop: 'adv_name',
        width: 90
      }, {
        label: '模型名称',
        prop: 'material_name'
      }, {
        label: '设计师',
        prop: 'designer_id'
      }, {
        label: '客户备注',
        prop: 'remark'
      }, {
        label: '计划完成日期（对内）',
        prop: 'estimated_deliver_time1',
        width: 100
      }, {
        label: '计划完成日期（对外）',
        prop: 'estimated_deliver_time2',
        width: 100
      }, {
        label: '实际完成日期',
        prop: 'deliver_time',
        width: 100
      }, {
        label: '关联项目ID',
        prop: 'project_id',
        width: 100
      }, {
        label: '坑位名称',
        prop: 'category_name'
      }, {
        label: '骨骼类型',
        prop: 'skeleton_type'
      }, {
        label: '创建时间',
        prop: 'created_time',
        width: 100
      }, {
        label: '修改时间',
        prop: 'updated_time',
        width: 100
      }];
    },
    dialogItemList: function dialogItemList() {
      var _this12 = this;

      return [{
        label: '模型名称',
        type: 'input',
        visible: !this.defaultInfo([5, 6, 7]),
        prop: 'material_name',
        width: 460,
        params: {
          disabled: true
        }
      }, {
        label: '骨骼类型',
        type: 'input',
        visible: !this.defaultInfo([5, 6, 7]),
        width: 460,
        prop: 'skeleton_type',
        params: {
          disabled: true
        }
      }, {
        label: '预计交付时间(对内)：',
        visible: this.dialog.type === 1,
        rules: [{
          required: true,
          message: '预计交付时间(对内)不能为空',
          trigger: 'blur'
        }],
        type: 'date-picker',
        subtype: 'date',
        prop: 'estimated_deliver_date1',
        params: {
          format: 'yyyy/MM/dd',
          pickerOptions: {
            disabledDate: function disabledDate(date) {
              var today = new Date();
              today.setDate(today.getDate() - 1);
              return date < today;
            }
          },
          placeholder: '请选择日期'
        }
      }, {
        label: '预计交付时间(对外)：',
        visible: this.dialog.type === 1,
        rules: [{
          required: true,
          message: '预计交付时间(对外)不能为空',
          trigger: 'blur'
        }],
        type: 'date-picker',
        subtype: 'date',
        prop: 'estimated_deliver_date2',
        params: {
          format: 'yyyy/MM/dd',
          pickerOptions: {
            disabledDate: function disabledDate(date) {
              var today = new Date();
              today.setDate(today.getDate() - 1);
              return date < today;
            }
          },
          placeholder: '请选择日期'
        }
      }, {
        label: '分配设计：',
        visible: this.dialog.type === 1,
        width: 460,
        rules: [{ required: true, message: '分配设计不能为空', trigger: 'change' }],
        type: 'select',
        prop: 'designer_id',
        params: {
          class: 'custom-width',
          filterable: true,
          options: this.designerList,
          placeholder: '请选择分配的设计',
          clearable: true
        }
      }, {
        label: '客户语言环境：',
        visible: this.dialog.type === 2,
        width: 460,
        type: 'input',
        prop: 'language',
        params: {
          disabled: true
        }
      }, {
        label: '拒绝理由：',
        visible: this.dialog.type === 2,
        type: 'input',
        rules: [{ required: true, message: '拒绝原因不能为空', trigger: 'change' }],
        subtype: 'autocomplete',
        prop: 'reason',
        params: {
          class: 'custom-width',
          clearable: true,
          triggerOnFocus: true,
          fetchSuggestions: function fetchSuggestions(queryString, cb) {
            cb(_this12.reasonList);
          },
          placeholder: '请输入拒绝原因'
        }
      }, {
        visible: this.dialog.type === 5,
        type: 'plain-text',
        prop: 'confirm_delivery',
        params: {
          class: 'confirmText'
        }
      }, {
        label: '封面图：',
        visible: this.dialog.type === 3 || this.dialog.type === 4,
        type: 'business',
        prop: 'cover_url',
        subtype: 'single-file-uploader',
        rules: [{ required: true, message: '请上传封面图', trigger: 'blur' }],
        params: {
          disabled: false,
          drag: true,
          accept: '.jpg,.png,.gif,.svg',
          maxSize: 2,
          'with-credentials': true,
          data: {
            allow_types: 'jpg,png,gif,svg'
          },
          tip: '格式：JPG、PNG、GIF、SVG格式,大小不超过2M',
          fileList: [],
          'on-remove': function onRemove(file, fileList) {
            _this12.dialog.value.cover_url = '';
          }
        }
      }, {
        label: '上传文件：',
        visible: this.dialog.type === 3 || this.dialog.type === 4,
        type: 'business',
        subtype: 'single-file-uploader',
        prop: 'deliver_url',
        rules: [{ required: true, message: '请上传文件', trigger: 'blur' }],
        params: {
          disabled: false,
          drag: true,
          maxSize: 5,
          'with-credentials': true,
          data: {
            unzip: 2,
            allow_types: 'zip'
          },
          accept: '.zip',
          tip: '格式：仅支持zip格式 (文件格式必须为 gltf/glb/(glb+bin)+jpg/png), 文件最大不能超过5M',
          fileList: [],
          'on-remove': function onRemove(file, fileList) {
            _this12.dialog.value.deliver_url = '';
          },
          handleSuccess: function handleSuccess(response) {
            _this12.dialog.value.check_url = response.data.url;
            _this12.isConverCocosModel = '';
            _this12.getModelInfo(response);
          }
        }
      }, {
        visible: this.dialog.type === 6,
        type: 'plain-text',
        prop: 'confirm_preview',
        params: {
          class: 'confirmText'
        }
      }, {
        visible: this.dialog.type === 7,
        type: 'plain-text',
        prop: 'withdraw_Order',
        params: {
          class: 'confirmText'
        }
      }];
    }
  },
  watch: {
    $route: function $route(to, from) {
      this.getOrderList(this.query);
    },
    'dialog.config.visible': function dialogConfigVisible(val) {
      if (val) {
        this.dialog.uploaderVisible = true;
      } else {
        this.dialog.uploaderVisible = false;
        this.dialog.config.disabled = false;
        this.$refs['dialog-form'].resetFields();
      }
    }
  }
};